"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var isDisabled = ui_blocks_1.INTERACTIVE.isDisabled,
    isClickable = ui_blocks_1.INTERACTIVE.isClickable,
    isClickableInverse = ui_blocks_1.INTERACTIVE.isClickableInverse;
var caption = ui_blocks_1.TYPOGRAPHY.caption;
exports.Button = styled_components_1.default.button(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  text-decoration: none;\n  white-space: nowrap;\n  color: ", ";\n  font-weight: ", ";\n  font-size: 1.5rem;\n  background: none;\n\n  &:first-of-type {\n    border-right: ", ";\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n  }\n  &:last-of-type {\n    border-left: ", ";\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n  }\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    ", "\n    border: 0.0625rem solid\n      ", ";\n  }\n\n  &:disabled:hover,\n  &[aria-disabled='true']:hover {\n    border: 0.0625rem solid\n      ", ";\n  }\n"], ["\n  ", "\n  ", "\n  ", "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  text-decoration: none;\n  white-space: nowrap;\n  color: ", ";\n  font-weight: ", ";\n  font-size: 1.5rem;\n  background: none;\n\n  &:first-of-type {\n    border-right: ", ";\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n  }\n  &:last-of-type {\n    border-left: ", ";\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n  }\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    ", "\n    border: 0.0625rem solid\n      ", ";\n  }\n\n  &:disabled:hover,\n  &[aria-disabled='true']:hover {\n    border: 0.0625rem solid\n      ", ";\n  }\n"])), isClickable, caption, function (_a) {
  var isInverse = _a.isInverse;
  return isInverse && isClickableInverse;
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.MEDIUM', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.REGULAR', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.DEFAULT_BORDER', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.DEFAULT_BORDER', theme);
}, isDisabled, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["300"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["300"]', theme);
});
var templateObject_1;